import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { SessionService } from './session.service';
import { ConfigService } from '../../config/config.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class UserService {

    private apiURI: string;

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService) {
        this.apiURI = config.apiURI;
    }

    urlDataDecoded(data) {
        let searchParams = new URLSearchParams();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                searchParams.set(key, data[key] + '');
            }
        }
        return searchParams.toString();
    }

    userLogin(user: any) {
        const body = 'username=' + user.username + '&password=' + user.password;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.fundraisingLogin, body, {
            headers: headers
        });
    }

    userOtpLogin(user: any) {
        const body = 'username=' + user.username;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.fundraisingOtpLogin, body, {
            headers: headers
        });
    }

    userLogout() {
        this.sessionService.unsubscribeFromForceRefresh();
        let user_token: string = this.sessionService.getToken();
        let body = {};
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        //headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.customerLogout, body, {
            headers: headers
        })
    }

    recoverPassword(email) {
        let body = 'username=' + email.username;
        if (email.market) {
            body += '&market=' + email.market;
        }
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.customerForgotPassword, body, {
            headers: headers
        });
    }

    recoverFundraisingPassword(email) {
        let body = 'username=' + email.username;
        const headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.fundraisingForgotPassword, body, {
            headers: headers
        });
    }


    userRegister(userData) {
        let body = this.urlDataDecoded(userData);
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.customerRegister, body, {
            headers: headers
        })
    }

    resetPassword(data, id, token) {
        let body = this.urlDataDecoded(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.resetPassword(id, token), body, {
            headers: headers
        })
    }

    resetPasswordFundraiser(data, id, token) {
        let body = this.urlDataDecoded(data);
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.resetFundraiser(id, token), body, {
            headers: headers
        })
    }

    checkUserMail(userMail) {
        return this.http.get(this.config.apiURI + this.config.checkUserMail + `?email=${userMail}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/user.service.ts